import { InputAdornment, makeStyles, MenuItem, Select } from "@material-ui/core";
import SortIcon from "@material-ui/icons/Sort";
import React from "react";
import { ThemeType } from "@theme";

export type SortOption = {
  active: boolean;
  label: React.ReactNode;
  value: string;
};

export type SortOptionsProp = {
  sortOptions?: SortOption[];
  onSortOption?: (v: SortOption) => void;
};

export function SortOptions(props: SortOptionsProp) {
  const classes = useStyles({});
  const { sortOptions, onSortOption } = props;

  if (!Array.isArray(sortOptions) || sortOptions.length === 0) {
    return null;
  }

  const selected = sortOptions.find((opt) => opt.active);
  return (
    <div className={classes.sorting}>
      <Select
        disableUnderline
        value={selected ? selected.value : null}
        startAdornment={
          <InputAdornment position="start">
            <SortIcon />
          </InputAdornment>
        }
        onChange={(e) =>
          onSortOption(sortOptions.find((o) => o.value === e.target.value))
        }
        data-test="Sorting"
      >
        {sortOptions.map((opt) => (
          <MenuItem key={opt.value} selected={opt.active} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  sorting: {
    ...theme.mixins.childrenMarginRight(theme.spacing()),
    display: "inline-flex",
    flex: "0 0 auto",

    "& > *": {
      alignItems: "center",
      display: "inline-flex",
      position: "relative"
    }
  },

  sortingActive: {
    fontWeight: theme.fontWeight.xBold
  },

  sortIcon: {
    position: "relative",
    bottom: 0,
    right: 4
  }
}));
